import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import reportWebVitals from './reportWebVitals';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import LoggingProvider from './services/logging/LoggingProvider';
import { DbxContextProvider } from './services/DbxContext';
import { Dbx } from './services/dbx';
import { LocationAddressReaction } from './services/locations/locations';
import { FirebaseContextProvider } from './services/firebase/FirebaseContext';
import { FireDataContextProvider } from './services/firebase/FireDataContext';
import { AuthProvider } from './services/firebase/AuthProvider';
import AppRoutes from './AppRoutes';


Dbx.subscribe(LocationAddressReaction);

ReactDOM.render(
  <React.StrictMode>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <FirebaseContextProvider>
        <FireDataContextProvider>
          <DbxContextProvider>
            <AuthProvider>
              <LoggingProvider>
                <AppRoutes />
              </LoggingProvider>
            </AuthProvider>
          </DbxContextProvider>
        </FireDataContextProvider>
      </FirebaseContextProvider>
    </MuiPickersUtilsProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
